export default __webpack_public_path__ + "static/media/sc7.a9689941.png";